import 'jquery-mousewheel';
import { queries as mq, setParentWidth } from '../utils/Utils';

const is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
const hash = location.hash.substr(1);
const $scrollContainer = $('#sidescroll');

export const ScrollController = () => {

  enquire.register(mq.desktop, {
    match : () => {
      window.isHorizontal = true;

      if($('.scroll-indicator').length < 1) {
        $('body').append('<div class="scroll-indicator"><div class="scroll-indicator__progress"></div></div>');
      }

      controlParentSize($scrollContainer, '.section');
      sideScroll($scrollContainer);
    },

    unmatch : () => {
      window.isHorizontal = false;
      unsetParentSize($scrollContainer);
      unsetHeaderItemClass();

      $('html, body').off("DOMMouseScroll mousewheel");

      if($('.scroll-indicator').length > 0) {
        $('.scroll-indicator').remove();
      }

    },
  });

  menuItems();
  logoClick();

  if(hash) {
    scrollToSection(hash, window.isHorizontal)
  }
}

const sideScroll = ($parent) => {
  //$.event.props.push("wheelDelta");
  $.easing.easeOutQuint = function (x, t, b, c, d) {
      return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
  };

  let docH = $(document).width() - $(window).width();
  // let scrollLeft = $(window).scrollLeft();
  let scrollTween;

  $('html, body').on('DOMMouseScroll mousewheel', (e, delta) => {
    if(window.allowScroll) {
      if(is_safari) {
        noScrollEasing(e, delta);
      } else {
        scrollEasing(e, delta, docH, scrollTween);
      }
    }
  });
}

const scrollEasing = (e, delta, docH, scrollTween) => {
  // clamp the scroll offset
  delta *= 2;
  window.scrollPos = Math.min(docH, Math.max(0, window.scrollPos - (delta || e.wheelDelta)));

  //TweenMax.to('body, html')
  if ( scrollTween !== undefined ){
    scrollTween.kill();
  }
  scrollTween = TweenMax.to(
    window,
    1.5, {
      scrollTo:{
        y:0,
        x: window.scrollPos
      },
      onUpdate: () => {
        scrollIndicator();
        setHeaderItemClass();
      }
    }
  );
}

const noScrollEasing = (e, delta) => {
  const $this = e.currentTarget;

  if(window.allowScroll) {
    if(Math.abs(e.originalEvent.deltaX)) {
      $this.scrollLeft -= (e.originalEvent.deltaX * 3) * -1;
    } else {
      $this.scrollLeft -= (delta * 3) * -1 * -1;
    }

    window.scrollPos = $(window).scrollLeft();

    scrollIndicator();
    setHeaderItemClass();
  }
  e.preventDefault();
}

const logoClick = () => {
  $('.logo a, .logo-lrg a').click((e) => {
    const $this = $(e.currentTarget);
    const target = $this.attr('data-target');

    $('body').removeClass('show-menu');
    window.allowScroll = true;

    scrollToSection(target);

    e.preventDefault();
    e.stopPropagation();
  })
}

const menuItems = () => {
  $('.main-nav__item').click((e) => {
    const $this = $(e.currentTarget);
    const target = $this.attr('data-target');

    $('body').removeClass('show-menu');
    window.allowScroll = true;

    scrollToSection(target);

    e.preventDefault();
    e.stopPropagation();
  })
}


const scrollToSection = (target) => {
  const $el = $('#' + target);
  let pos = 0;

  if(window.isHorizontal) {

    if($el.length > 0) {
      pos = $el.offset().left;
    }

    $('html, body').animate({
      scrollLeft: pos
    }, 500);

    window.scrollPos = pos;

    scrollIndicator();
    setHeaderItemClass();

  } else {

    if($el.length > 0) {
      pos = $el.offset().top;
    }

    $('html, body').animate({
      scrollTop: pos
    }, 500);

    window.scrollPos = pos;
  }


}


const controlParentSize = ($parent, children) => {
  if($parent.length > 0) {
    setParentWidth($parent, children);

    $(window).on("window:resize", (e) => {
      setParentWidth($parent, children);
    })
  }
}


const unsetParentSize = ($parent) => {
  if($parent.length > 0) {
    $parent.css({width: ''});

    $(window).on("window:resize", (e) => {
      $parent.css({width: ''});
    })
  }
}


const setHeaderItemClass = () => {
  const $headerItems = $('.social-nav li, .logo, #pagetitle, .toggle-menu');
  const sectionPos = document.querySelector('.section.brewery').getBoundingClientRect().x

  $headerItems.each((i, el) => {
    const elBounding = el.getBoundingClientRect()
    const elCenter = elBounding.x + (elBounding.width / 2);

    if(sectionPos < elCenter) {
      $(el).addClass('dark')
    } else {
      $(el).removeClass('dark')
    }
  });
}


const unsetHeaderItemClass = () => {
  const $headerItems = $('.social-nav li, .logo, #pagetitle, .toggle-menu');
  $headerItems.each((i, el) => {
    $(el).removeClass('dark')
  });
}


const scrollIndicator = () => {
  const documentWidth = $(document).width();
  const windowWidth = $(window).width();
  const scrollPosition = window.scrollPos;
  const positionPercentage = (scrollPosition / documentWidth) * 100;
  const offset = (windowWidth / documentWidth)  * positionPercentage;
  const percentage = positionPercentage + offset;
  // console.log(percentage);
  $('.scroll-indicator__progress').css({'width': (percentage > 95) ? Math.ceil(percentage) + 1 + '%' : percentage + '%'});
}



// WEBPACK FOOTER //
// ./src/js/controllers/ScrollController.js